import useModal from "../../../useModal";
import Modalheader from "../../../components/header";
import ModalBody from "../../../components/body";
import ModalFooter from "../../../components/footer";
import Button from "../../../../button";
import React, {useEffect, useState} from "react";
import ApiDatabase from "../../../../../server";
import UseContext from "../../../../../hooks/useContext";
import {dateWordShort} from "../../../../../helper/helper";
import Divider from "../../../../divider/divider";

const ModalMissionPanel = () => {
    const {toggle} = useModal()
    const {companyData, idMission, setIdMission} = UseContext()
    const [missionData, setMissionData] = useState({})
    const [isWaiting, setIsWaiting] = useState(true)
    const token = localStorage.getItem('xsrfToken')

    useEffect(() => {
        if (idMission && companyData?._id) {
            setIsWaiting(true)
            ApiDatabase.getMissionInfo({id: idMission},
                (data) => {
                    setMissionData(data ?? {})
                    setIsWaiting(false);
                },
                (err) => {
                    console.log(err)
                    setIsWaiting(false)
                })
        }
    }, [idMission, companyData])

    const hideModal = () => {
        toggle()
        setIdMission('')
    }

    return (
        <>
            <Modalheader>
                <div className={'flex justify-between items-center'}>
                    <div className={'text-xl font-semibold'}>Mission</div>
                </div>
            </Modalheader>
            <ModalBody>
                {isWaiting ? (
                    <div className="flex justify-center items-center py-8">
                        <div className="text-gray-500">Chargement...</div>
                    </div>
                ) : (
                    <div className="space-y-4">
                        {missionData?.title && (
                            <>
                                <div>
                                    <div className="text-sm text-gray-500 mb-1">Titre</div>
                                    <div className="text-base font-medium">{missionData.title}</div>
                                </div>
                                <Divider/>
                            </>
                        )}
                        {missionData?.id_mission && (
                            <>
                                <div>
                                    <div className="text-sm text-gray-500 mb-1">Numéro de mission</div>
                                    <div className="text-base">n°{missionData.id_mission}</div>
                                </div>
                                <Divider/>
                            </>
                        )}
                        {missionData?.duration && (
                            <>
                                <div>
                                    <div className="text-sm text-gray-500 mb-1">Période</div>
                                    <div className="text-base">
                                        {missionData.duration.datestart && dateWordShort(missionData.duration.datestart)}
                                        {missionData.duration.datestart && missionData.duration.dateend && ' - '}
                                        {missionData.duration.dateend && dateWordShort(missionData.duration.dateend)}
                                    </div>
                                </div>
                                <Divider/>
                            </>
                        )}
                        {missionData?.location && (
                            <>
                                <div>
                                    <div className="text-sm text-gray-500 mb-1">Localisation</div>
                                    <div className="text-base">{missionData.location}</div>
                                </div>
                                <Divider/>
                            </>
                        )}
                        {missionData?.activity && (
                            <>
                                <div>
                                    <div className="text-sm text-gray-500 mb-1">Activité</div>
                                    <div className="text-base">{missionData.activity}</div>
                                </div>
                                <Divider/>
                            </>
                        )}
                        {missionData?.qualification && (
                            <>
                                <div>
                                    <div className="text-sm text-gray-500 mb-1">Qualification</div>
                                    <div className="text-base">{missionData.qualification}</div>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button size={'LG'} color={'SECONDARY'} onClick={hideModal}>Fermer</Button>
            </ModalFooter>
        </>
    );
}

export default ModalMissionPanel;

